import { ThemeProvider as StyledThemeProvider } from "styled-components";

import { ThemeInMode } from "../../styles/themes/types";

type Props = { themeInMode: ThemeInMode; children: React.ReactNode };

export default function ThemeProvider({ themeInMode, children }: Props) {
  return (
    <StyledThemeProvider theme={themeInMode}>{children}</StyledThemeProvider>
  );
}
